// referenced from confluence/next/packages/network/src/getTraceIdFromResponse.ts

export const getTraceIdFromResponse: (response: Response | undefined) => string | null = (
	response: Response | undefined,
) => response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;
